export type WorkingDayKey =
  | 'mon'
  | 'tue'
  | 'wed'
  | 'thu'
  | 'fri'
  | 'sat'
  | 'sun'

export const WORKING_DAY_KEYS: WorkingDayKey[] = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun',
]

export const WORKING_DAY_LABELS: Record<WorkingDayKey, string> = {
  mon: 'M',
  tue: 'T',
  wed: 'W',
  thu: 'T',
  fri: 'F',
  sat: 'S',
  sun: 'S',
}

export const WORKING_DAY_TITLES: Record<WorkingDayKey, string> = {
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
}

export type WorkingDayState = 'available' | 'unavailable'

export const WORKING_DAY_STATES: WorkingDayState[] = [
  'available',
  'unavailable',
]

export const WORKING_DAY_STATE_LABELS: Record<WorkingDayState, string> = {
  available: 'Available',
  unavailable: 'Unavailable',
}

/** Weekdays Mon–Fri selected (common Provider Management default). */
export const WORKING_DAYS_WEEKDAY_VALUE: WorkingDayKey[] = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
]

export type WorkingDaysProps = {
  /** Days marked as available / selected. */
  value?: WorkingDayKey[]
  defaultValue?: WorkingDayKey[]
  /**
   * When true, clicking a day toggles availability.
   * Default false (display-only, as in Provider Management table).
   */
  interactive?: boolean
  disabled?: boolean
  darkMode?: boolean
  className?: string
  /**
   * Static showcase helper: force every day into one visual state.
   * Ignored when `previewValue` is set.
   */
  previewState?: WorkingDayState
  /** Static available days for the design-system showcase only. */
  previewValue?: WorkingDayKey[]
  onChange?: (value: WorkingDayKey[]) => void
  onDayClick?: (day: WorkingDayKey, nextAvailable: boolean) => void
}
